import { render, staticRenderFns } from "./experience-card.vue?vue&type=template&id=5a189efc&scoped=true&"
import script from "./experience-card.vue?vue&type=script&lang=ts&"
export * from "./experience-card.vue?vue&type=script&lang=ts&"
import style0 from "./experience-card.vue?vue&type=style&index=0&id=5a189efc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a189efc",
  null
  
)

export default component.exports